var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-cell-group',_vm._l((_vm.schema.grids),function(item,idx){return _c('van-cell',{key:idx,attrs:{"title":item.text,"value":item.rightText,"label":item.label,"is-link":""},on:{"click":function($event){return _vm.actionPlugin('grids',idx)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }